import api from "../../store/services/api";

export const getDeliveryCenter = (params) =>
  api.get("/delivery-center/", { params });

export const getDeliveryCenterServiceFee = (params) =>
  api.get("/delivery-center/fees/", { params });

export const getDeliveryCenterFiscal = (params) =>
  api.get("/delivery-center/fiscal/company/", { params });

export const setDeliveryCenterServiceFee = (feesObj) =>
  api.put("/delivery-center/fees/", feesObj, {
    headers: { "Content-Type": "application/json" },
  });

export const getDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue = (
  params
) =>
  api.get(
    "/delivery-center/shipping-route-secondary-order-delivery-tax-value/",
    { params }
  );

export const setDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue = (
  feesObj
) =>
  api.put(
    "/delivery-center/shipping-route-secondary-order-delivery-tax-value/",
    feesObj,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const createDeliveryCenter = (deliveryCenter) =>
  api.post("/delivery-center/", deliveryCenter, {
    headers: { "Content-Type": "application/json" },
  });

export const editDeliveryCenter = (deliveryCenterId, deliveryCenterObj) =>
  api.put(`/register/agent/?id=${deliveryCenterId}`, deliveryCenterObj, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDeliveryCenter = (deliveryCenterId) =>
  api.delete(`/register/agent/?id=${deliveryCenterId}`);

export const getDeliveryCenterConfig = (params) =>
  api.get("/delivery-center/config/", { params });

export const setDeliveryCenterConfig = (data) =>
  api.put("/delivery-center/config/", data, {
    headers: { "Content-Type": "application/json" },
  });

const DeliveryCenterService = {
  getDeliveryCenter,
  createDeliveryCenter,
  editDeliveryCenter,
  deleteDeliveryCenter,
};

export default DeliveryCenterService;
